import React from "react";
import { connect } from "react-redux";
import T from "prop-types";
import { Col } from "react-bootstrap";
import { API_BASE } from "APP_ROOT/constants";
import { ATTACHMENT_TYPES } from "MODULES/MistakeShipments/constants";
import DashedSeparator from "MODULES/shared/components/DashedSeparator";
import Actions from "MODULES/MistakeShipments/components/Detail/Actions";
import {
  Attachments,
  AuditFields,
  ClipboardCopy,
  Notes,
  RecordPager
} from "MODULES/shared/components";
import resourceTypes from "../../../shared/types/resourceTypes";
import { DetailsTable } from "./DetailsTable";
import loadRecord from "../../../shared/decorators/loadRecord";
import { show } from "../../actions";
import ShipTo from "./ShipTo";
import { ShippingPreference } from "../../../Orders/shared/ShippingPreference";

function Detail({ mistakeShipment }) {
  const parsedMistakeShipment = mistakeShipment.toJS();
  const id = mistakeShipment.get("id");
  const packingSlipUrl = `${API_BASE}/mistake_shipments/${id}/download_packing_slip`;

  return (
    <Col>
      <div className="page-header page-header-bar">
        <h1>
          <div className="with-padding">
            <RecordPager
              baseUrl="/mistake-shipments"
              record={mistakeShipment}
            />
            <span className="header-content">
              {mistakeShipment.get("code")}
            </span>
            <ClipboardCopy
              name={mistakeShipment.get("code")}
              type="Mistake Shipment"
            />
            <Actions url={packingSlipUrl} mistakeShipment={mistakeShipment} />
          </div>
        </h1>
      </div>
      <Col md={3}>
        <div className="panel panel-default">
          <div className="panel-body">
            <DetailsTable mistakeShipment={parsedMistakeShipment} />
            <DashedSeparator />
            <ShipTo />
            <ShippingPreference
              shippingMethod={parsedMistakeShipment.shipping_method}
            />
            <DashedSeparator />
            <AuditFields record={mistakeShipment} multiLine />
          </div>
        </div>
      </Col>
      <Col md={9}>
        <Notes
          resource={mistakeShipment}
          resourceType={resourceTypes.mistakeShipment}
          resourceKey="mistakeShipment"
        />
        <Attachments
          multiple
          resource={mistakeShipment}
          resourceType={resourceTypes.mistakeShipment}
          resourceKey="mistakeShipment"
          attachmentTypes={ATTACHMENT_TYPES}
        />
      </Col>
    </Col>
  );
}

Detail.propTypes = {
  mistakeShipment: T.instanceOf(Map)
};

export default connect(state => ({
  mistakeShipment: state.mistakeShipmentDetail.get("mistakeShipment")
}))(
  loadRecord({
    reducer: "mistakeShipmentDetail",
    name: "mistakeShipment",
    action: show
  })(Detail)
);



// WEBPACK FOOTER //
// ./app/modules/MistakeShipments/components/Detail/Detail.jsx